// extracted by mini-css-extract-plugin
export var form = "Kontakt-module--form--4FWdp";
export var kontaktContainer = "Kontakt-module--kontaktContainer--ae+r-";
export var kontaktText = "Kontakt-module--kontaktText--cR3s7";
export var note = "Kontakt-module--note--N86mZ";